import { useContext } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { enrollmentContext } from '../components/hoc/context/enrollment/enrollment-context';
import useProduct from './useProduct';

export type FormField = {
	name: string;
	help?: boolean;
	question?: string;
	service?: string;
	options?: { key: string; value: string }[];
};

export interface Form {
	id: string;
	help?: boolean;
	service?: string;
	fields: FormField[];
	getField(name: string): FormField | undefined;
}

export interface Configuration {
	form: Form[];
	getForm(id: string): Form | undefined;
	filterForms(): Form[];
}

export default function useForms(): Configuration {
	const productConfig = useProduct();
	const { performer, input } = useContext(enrollmentContext);
	const { config } = useStaticQuery<{ config: Configuration }>(graphql`
		query {
			config: formsConfiguration {
				form {
					fields {
						help
						name
						options {
							key
							value
						}
						service
					}
					help
					id
					service
				}
			}
		}
	`);

	config.getForm = (formId: string) => {
		return config.form.find((form) => form.id === formId);
	};

	config.filterForms = () => {
		return config.form.filter((form) => {
			if (!form.service) {
				return true;
			}
			const service = productConfig.services.find(
				(configService) => configService.name === form.service
			);
			if (service) {
				return (
					!input.discardedServices.includes(form.service) &&
					service.isEligible(performer, input.questions, input.consents)
				);
			}
			return false;
		});
	};

	config.form.forEach((form) => {
		form.getField = (name: string) => {
			return form.fields.find((field) => field.name === name);
		};
	});

	return config;
}
